export const SHOW_SEARCHBAR = "SHOW_SEARCHBAR";
export const PRODUCT_SEARCH = "PRODUCT_SEARCH";
